import * as React from 'react';
import { useState } from 'react';
import { Keyboard } from 'react-native';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    isWeb,
    KeyboardCompatibleBottomSheetTextInput,
    StyledBodyMediumRegularInput,
    YStack,
} from 'smoothie';

const MAX_DESCRIPTION_LENGTH = 50;

interface RecurringTransferDescriptionProps {
    onSubmit: (description?: string) => void;
    description?: string;
}

const RecurringTransferDescription = ({
    description,
    onSubmit,
}: RecurringTransferDescriptionProps) => {
    const [enteredDescription, setEnteredDescription] = useState(
        description ?? '',
    );

    return (
        <YStack width="100%" alignItems="center">
            <YStack
                width="100%"
                alignItems="center"
                gap={8}
                paddingHorizontal={8}
            >
                <KeyboardCompatibleBottomSheetTextInput
                    // Web: autofocus makes the browser scroll the page to the field while
                    // the sheet is mounting; native keeps keyboard UX without that jump.
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus={!isWeb}
                    component={StyledBodyMediumRegularInput}
                    value={enteredDescription}
                    borderWidth={0}
                    textAlign="left"
                    backgroundColor="$gray100"
                    borderRadius={12}
                    width="100%"
                    height={54}
                    placeholder="Add a description"
                    enablesReturnKeyAutomatically
                    returnKeyType="done"
                    onChangeText={(text: string) => {
                        if (text.length <= MAX_DESCRIPTION_LENGTH) {
                            setEnteredDescription(text);
                        }
                    }}
                    onSubmitEditing={() => {
                        Keyboard.dismiss();
                    }}
                />
                <BodyMediumRegular
                    color={
                        enteredDescription.length > MAX_DESCRIPTION_LENGTH
                            ? '$red1100'
                            : '$gray1000'
                    }
                >
                    {enteredDescription.length}/{MAX_DESCRIPTION_LENGTH}
                </BodyMediumRegular>
            </YStack>
            <YStack marginTop={32} width="100%">
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Save"
                    onPress={() => {
                        onSubmit(enteredDescription);
                    }}
                />
            </YStack>
        </YStack>
    );
};

export default RecurringTransferDescription;
